import React, { useState } from 'react';
import {
    Card, CardContent, Typography, Button,
    CardHeader, Badge, Avatar, CardActions, Grid, Box
} from '@mui/material';
import { Icon } from '@iconify/react';
import PostContentDialog from '../views/apps/channel/dialogs/PostContentDialog';
import { Link } from 'react-router-dom';
import MediumBadge from './MediumBadge';


const IndividualPost: React.FC<any> = ({ post, campaign }) => {
    const { picture, channelName, message, channelTypeName, mediumName, objectPicture, isEditable, pendingPostLink /*footerMessage*/ } = post;
    const [showPostContentDialog, setShowPostContentDialog] = useState<boolean>(false);



    return (
        <>
            <Card variant="outlined" sx={{ mb: 2 }}>
                <CardHeader
                    avatar={
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={<MediumBadge channelTypeName={channelTypeName} mediumName={mediumName} />}
                        >
                            <Avatar alt={channelName} src={picture} />
                        </Badge>
                    }
                    title={channelName}
                />
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {message}
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {
                                    objectPicture && <img
                                        src={objectPicture}
                                        alt="Description"
                                        style={{
                                            maxWidth: '100px',
                                            maxHeight: '100px',
                                            borderRadius: '5px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <Typography variant="body2" color="textSecondary" component="p" sx={{ flexGrow: 1 }}>
                        {/*footerMessage*/}
                    </Typography>
                    {isEditable && <Button variant="outlined" size="small" onClick={() => setShowPostContentDialog(true)}>Edit</Button>}
                    {pendingPostLink && <Link to={pendingPostLink} target="_blank" rel="noopener noreferrer"><Button variant="outlined" size="small">Approve Post</Button></Link>}
                </CardActions>
            </Card>

            {showPostContentDialog && <PostContentDialog
                show={showPostContentDialog}
                setShow={setShowPostContentDialog}
                campaign={campaign}
                prefilledModelData={post}
            />
            }

        </>
    );
};

export default IndividualPost;